module.exports = __webpack_public_path__ + "img/pc-text.e9dc89f4.png";